export default "__VITE_ASSET__CED4Uk0L__"